<template>
  <div :class="{ disabled: disabled }" class="country-select btn-group w-100">
    <button
      :class="{ disabled: disabled }"
      class="cotizarlo-select main-input dropdown-toggle w-100"
      type="button"
      id="menuCountry"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <hollow-dots-spinner v-if="loading" dark />
      <template v-else>
        <span :class="{ 'text-black-50': disabled }">{{ countryName }}</span>
        <img
          v-if="!disabled"
          class="dropdown-icon ml-2"
          src="@/assets/icons/abajo.svg"
          width="15px"
        />
      </template>
    </button>

    <div
      class="country-select-list dropdown-menu dropdown-select-menu w-100"
      aria-labelledby="menuCountry"
    >
      <div
        class="dropdown-item d-flex py-1"
        v-for="country in countries"
        :key="'country-' + country.id"
        @click="countryId = country.id"
      >
        <span>{{ country.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import HollowDotsSpinner from '../Common/HollowDotsSpinner.vue';

export default {
  name: "CountrySelect",
  components: { HollowDotsSpinner },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    countries: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    countryId: {
      get() {
        return this.value;
      },
      set(countryId) {
        return this.$emit("input", countryId);
      },
    },
    countryName() {
      let name = "País/Región*";

      if (this.country.name) {
        name = this.country.name;
      }

      return name;
    },
    country() {
      let country = { id: "", name: "" };

      if (this.countries.length > 0) {
        country = this.countries.find((c) => c.id === this.countryId);
      }

      return country;
    },
  },
};
</script>

<style>
.country-select-list {
  max-height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.country-select.disabled button {
    cursor: default;
}
</style>
